import React from "react";
import { InputError } from "../labels";

const FormGroupVerticalInput = ({children, className, error}) => {
    return (
        <div className={`flex flex-col ${className}`}>
            {children}
            {error && <InputError error={error} />}
        </div>
    )
};

export default FormGroupVerticalInput;